import React, { useState } from 'react';
import cn from 'classnames';
import { uuid as generateUuid } from 'utils/dom';
import { sanitize } from 'utils/validation';
import { analyticsInteraction } from 'utils/analytics';
import { ANALYTICS } from 'constants';
import Button from 'components/Button';
import { propTypes } from './PolicyTabPropTypes';

const PolicyTab = (props) => {
  const { name, content, disabled, expanded, index, onToggle } = props;

  const isControlled = typeof onToggle === 'function';
  const [internalExpanded, setInternalExpanded] = useState(expanded);
  const isExpanded = isControlled ? expanded : internalExpanded;

  const uuid = generateUuid();

  const handleToggle = (e) => {
    e.preventDefault();

    // Analytics
    analyticsInteraction(ANALYTICS.DRAWER, name, isExpanded ? ANALYTICS.CLOSE : ANALYTICS.OPEN);

    if (onToggle) {
      onToggle({ index, uuid, isExpanded });
    } else {
      setInternalExpanded((prev) => !prev);
    }
  };

  return (
    <div className={cn('policy-tab', { disabled, expanded: !disabled && isExpanded })}>
      <h3 className='policy-tab__wrapper'>
        <Button
          plain
          className='policy-tab__toggler'
          id={uuid}
          role='tab'
          aria-label={name}
          aria-expanded={isExpanded.toString()}
          aria-controls={`${uuid}__drawer`}
          onClick={handleToggle}
        >
          <span className='policy-tab__title'>{name}</span>
        </Button>
      </h3>

      <div
        className={`policy-tab__drawer`}
        id={`${uuid}__drawer`}
        aria-labelledby={uuid}
        role='tabpanel'
        aria-hidden={!isExpanded || disabled}
      >
        {isExpanded && <div className='policy-tab__content' dangerouslySetInnerHTML={sanitize(content)} />}
      </div>
    </div>
  );
};

PolicyTab.propTypes = propTypes;

export default PolicyTab;
